// binaryClient.js
import { create } from "apisauce";
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import firebaseConfig from "@serie3/mymediaplanner/Config/Firebase/firebase";
import getSettings from "../config/settings";

const settings = getSettings();

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);

const binaryClient = create({
  baseURL: settings.apiUrl,
  responseType: "blob",
});

// attach token on every request
binaryClient.addAsyncRequestTransform(async (request) => {
  const user = auth.currentUser;

  let idToken = null;
  let uid = null;

  if (user) {
    try {
      idToken = await user.getIdToken(); // auto-refreshed if needed
      uid = user.uid;
    } catch {}
  } else {
    // legacy fallback (while migrating away from localStorage)
    try {
      idToken = JSON.parse(localStorage.getItem("token") || "null");
      uid = JSON.parse(localStorage.getItem("localId") || "null");
    } catch {}
  }

  if (!idToken) return;

  request.headers["x-auth-token"] = idToken;
  request.headers["x-auth-id"] = uid || "";
  request.headers["Authorization"] = `Bearer ${idToken}`;
});

// minimal central error handling (mirrors client.js)
binaryClient.addResponseTransform((response) => {
  switch (response.status) {
    case 500:
      window.location.replace("/uuuups");
      break;
    case 403:
      if (window.location.hostname === "stage.mynomadplace.com") {
        window.location.replace("/datareset");
      }
      break;
    case 422:
      localStorage.removeItem("token");
      localStorage.removeItem("localId");
      window.location.replace("/requestemailvalidation");
      break;
    // 404 is a per-file answer (the document row exists, its bytes are gone):
    // the caller shows a placeholder. Never leave the page for it.
    case 402:
      window.location.replace("/plans");
      break;
  }
});

export default binaryClient;
